import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationItemComponent } from '@app/core/header/components/notifications/notification-item/notification-item.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NotificationItemComponent],
  exports: [NotificationItemComponent]
})
export class NotificationItemModule {}
